<template>
  <div>
    <page-header :actions="pageActionConfig" :page="pageConfig" />
    <board class="mb-4" :details="detailsBoard" />
    <custom-separator class="my-4" text="Resultados" />
    <custom-result-not-found
      v-if="response?.documents.length === 0"
      text="No hay información disponible."
    />

    <!-- Mostrar response de análisis -->
    <div
      v-for="(result, index) in response?.documents"
      :key="index"
      class="result-item"
    >
      <div class="result-content">
        <div class="row col-12">
          <div class="row col-12">
            <div class="col-12 col-md-8">
              <section-title
                id="reinbursement-document-title"
                class="mt-4"
                has-line
                :title="result.documentTypeName"
              />
            </div>
            <div class="col-4 d-flex align-items-center justify-content-end">
              <action-button
                class="px-1 mx-1 download-btn"
                i="fas fa-file-download px-2 mx-0"
                variant="success"
                @click="onDownload(result.documentId)"
              />
            </div>
          </div>
        </div>

        <pre class="ml-4">{{ result.aiExtractionJsonResult }}</pre>
      </div>
    </div>

    <!-- Mostrar resultado en base a decisión -->
    <div v-if="response?.documents.length > 0" class="result-item">
      <div class="result-content">
        <section-title
          id="reinbursement-document-title"
          class="mt-4"
          has-line
          title="Resultado"
        />

        <div class="row">
          <div
            v-if="response.isEligibleForApproval"
            class="col-12 col-md-3 mt-4"
          >
            <custom-balloon
              background-color="bg-green"
              class="w-md-90 w-100 m-0"
              text="Aprobación Sugerida"
            />
          </div>
          <div v-else class="col-12 col-md-3 mt-4">
            <custom-balloon
              background-color="bg-yellow"
              class="w-md-90 w-100 m-0"
              text="No Sugerido para Aprobación"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import CustomInput from 'CustomInput';
import CustomSeparator from 'custom-separator';
import PageHeader from '@/shared/components/PageHeader/PageHeader';
import ActionButton from 'ActionButton';
import CustomResultNotFound from 'custom-result-not-found';
import SectionTitle from 'SectionTitle';
import CustomBalloon from 'custom-balloon';
import { aiValidateRequest as _aiValidateRequest } from '@/modules/reinbursement/api.js';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import appServices from '@/modules/app/api.js';
import Board from 'Board';
import moment from 'moment';

export default {
  name: 'AIValidation',
  components: {
    PageHeader,
    ActionButton,
    // CustomInput,
    CustomResultNotFound,
    CustomSeparator,
    SectionTitle,
    CustomBalloon,
    Board,
  },
  mixins: [alertMixin],
  data() {
    return {
      requestNumber: '',
      response: {
        isEligibleForApproval: true,
        documents: [],
        requestDetail: {},
      },
    };
  },
  computed: {
    pageConfig() {
      return {
        icon: 'fas fa-book',
        title: 'Validación de Reembolso',
        routes: [
          'Inicio',
          'Proveedor',
          'Manejo de Reembolso y Pago Directo',
          'Validación',
        ],
      };
    },
    pageActionConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => {
            this.$router.push({ name: 'Reimbursement' });
          },
        },
      ];
    },
    requestId() {
      return this.$route.params.requestId;
    },
    detailsBoard() {
      let items = [
        {
          label: 'Año Académico:',
          icon: 'fas fa-calendar-edit',
          data: this.response.requestDetail.academicYearDescription,
          cols: 'col-md-3 col-12',
        },
        {
          label: 'Número de Solicitud:',
          icon: 'fa fa-file-invoice',
          data: this.response.requestDetail.requestNumber ?? '-',
          cols: 'col-md-3 col-12',
        },
        {
          label: 'Estudiante:',
          icon: 'fas fa-address-book',
          data: this.response.requestDetail.studentNameSie,
          cols: 'col-md-3 col-12',
        },
        {
          label: 'Periodo:',
          icon: 'fas fa-calendar',
          data: this.selectedPeriods(this.response.requestDetail.periods),
          cols: 'col-md-3 col-12 mt-3',
        },
        {
          label: 'Servicio:',
          icon: 'fas fa-ballot-check',
          data: this.selectedServices(
            this.response.requestDetail.selectedServices
          ),
          cols: 'col-md-3 col-12 mt-3',
        },
        {
          label: 'Costo:',
          icon: 'fas fa-ballot-check',
          data: `$${this.response.requestDetail.amount}`,
          cols: 'col-md-3 col-12 mt-3',
        },
      ];

      return [items];
    },
    selectedPeriods() {
      return (periods) => {
        if (!periods?.length) return '-';
        const periodNames = periods.map((p) => {
          const monthName = moment()
            .month(p.monthNumber - 1)
            .format('MMMM');

          const capitalizedMonth =
            monthName[0].toUpperCase() + monthName.slice(1).toLowerCase();

          return `${capitalizedMonth} ${p.year}`;
        });

        return periodNames.join(', ');
      };
    },
    selectedServices() {
      return (services) => {
        if (!services?.length) return '-';
        return services.map((s) => s.serviceName).join(', ');
      };
    },
    selectedServicesCost() {
      return (services) => {
        if (!services?.length) return '-';
        return services
          .map((s) => {
            return `$${s.cost}`;
          })
          .join(', ');
      };
    },
  },
  async mounted() {
    await this.validateRequest();
  },
  methods: {
    async validateRequest() {
      try {
        var { data } = await _aiValidateRequest(this.requestId);
        this.response = data;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message ||
          error.response?.data?.errors?.errors?.[0] ||
          error.message ||
          'Error desconocido';
        this.ShowToast('Alerta', errorMessage, 'error');
        return;
      }
    },
    async onDownload(documentId) {
      await appServices.downloadDocument(documentId);
    },
  },
};
</script>
